import AnnouncementIcon from '@mui/icons-material/Announcement';
import { Button, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';

const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { palette } = useTheme();
  const errorColor = 'black';

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        textAlign: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <AnnouncementIcon sx={{ color: errorColor, fontSize: 42 }} />
      <Typography color={errorColor}>
        An unexpected issue has occurred. Our team is actively working on a
        resolution.
      </Typography>
      {process.env.NODE_ENV === 'development' && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
          Check browser console for error details
        </Typography>
      )}
      <Button onClick={(() => window.location.reload())}>
        Retry
      </Button>
    </Box>
  );
};

export default Fallback;

